import { createStore } from 'zustand'

import { localdb } from '../../utils/store'

import { ApplicationStore } from './interface'

const APPLICATION_STORE_LOCAL_STORAGE_KEY = 'applicationStore'

export const applicationStore = createStore<ApplicationStore>()((set, get) => {
  // 更新 value 并且持久化到 localStorage
  const setValueWithPersistent = (
    partial: Partial<ApplicationStore>,
    replace?: false
  ) => {
    const localStore = localdb.get(APPLICATION_STORE_LOCAL_STORAGE_KEY, {})
    const newLocalStore = { ...localStore, ...partial }
    localdb.set(APPLICATION_STORE_LOCAL_STORAGE_KEY, newLocalStore)
    set(partial, replace)
  }

  return {
    logReport: true,
    getLogReport() {
      return get().logReport
    },
    setLogReport(value) {
      setValueWithPersistent({
        logReport: value
      })
    },
    apiHint: '',
    getApiHint() {
      return get().apiHint
    },
    setApiHint(value) {
      setValueWithPersistent({
        apiHint: value
      })
    },
    cipherEnabled: true,
    getCipherEnabled() {
      return get().cipherEnabled
    },
    setCipherEnabled(value) {
      setValueWithPersistent({
        cipherEnabled: value
      })
    },
    cipherConfig: {
      secret: 'w+02u8qauQ6JepeRRrXs162Aqu1gwfP1Jq/nCikMziQ=',
      iv: 'mgDXx3ZK3SYLFuoLMYyPpA=='
    },
    getCipherConfig() {
      return get().cipherConfig
    },
    ...localdb.get(APPLICATION_STORE_LOCAL_STORAGE_KEY, {})
  }
})
